export default function AboutUs1(){
    return (
        <section className="py-24 relative bg-gray-900">
        <div className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
            <div className="w-full justify-start items-center gap-12 grid lg:grid-cols-2 grid-cols-1">
                <div
                    className="w-full justify-center items-start gap-6 grid sm:grid-cols-2 grid-cols-1 lg:order-first order-last">
                    <div className="pt-24 lg:justify-center sm:justify-end justify-start items-start gap-2.5 flex">
                        <img className=" rounded-xl object-cover" src="/images/leopard.jpg" alt="about Us" />
                    </div>
                    <img className="sm:ml-0 ml-auto rounded-xl object-cover" src="/images/elephant.jpg"
                        alt="about Us" />
                </div>
                <div className="w-full flex-col justify-center lg:items-start items-center gap-10 inline-flex">
                    <div className="w-full flex-col justify-center items-start gap-8 flex">
                        <div className="w-full flex-col justify-start lg:items-start items-center gap-3 flex">
                            <h2
                                className="text-green-700 text-4xl font-bold font-manrope leading-normal lg:text-start text-center">
                                Our Goal</h2>
                            <p className="text-white text-base font-normal leading-relaxed lg:text-start text-center">
                                The goal of WITS is to improve data accuracy, detection of illegal wildlife activities, and
transparency, thereby contributing to species protection, ecosystem restoration, and stronger
conservation policies. By enabling real-time tracking of incidents and conservation interventions,
WITS empowers decision-makers with the evidence they need to act quickly and effectively:</p>
                        </div>
                        <div className="w-full lg:justify-start justify-center items-center sm:gap-10 gap-5 inline-flex">
                            <div className="flex-col justify-start items-start inline-flex">
                                <h3 className="text-white text-4xl font-bold font-manrope leading-normal">600+</h3>
                                <h6 className="text-white text-base font-normal leading-relaxed">Incidents Tracked By WITS</h6>
                            </div>
                            <div className="flex-col justify-start items-start inline-flex">
                                <h4 className="text-white text-4xl font-bold font-manrope leading-normal">90+</h4>
                                <h6 className="text-white text-base font-normal leading-relaxed">Endangered Species Involved</h6>
                            </div>
                            <div className="flex-col justify-start items-start inline-flex">
                                <h4 className="text-white text-4xl font-bold font-manrope leading-normal">80+</h4>
                                <h6 className="text-white text-base font-normal leading-relaxed">Successful Convictions Tracked</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
                                            
    )
}